// ** Router imports
import { useRoutes } from 'react-router-dom';

// ** GetRoutes
import PropTypes from 'prop-types';
import { verifyLayoutElement } from './routes';

// ** Hooks Imports

export const Router = ({ routes }) => {
  return useRoutes([...verifyLayoutElement(routes)]);
};

Router.propTypes = {
  routes: PropTypes.array.isRequired
};
export default Router;
